import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";
import { calculateColumnTotal } from "../General/Utility";

const PrintAdvanceReceived = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [loading, setLoading] = useState(false);
  const [listOfLedger, setLedger] = useState([]);
  const [StartDate, setStartDate] = useState("");
  const [EndDate, setEndDate] = useState("");

  document.title = "Print Advance Received Report";

  useEffect(() => {
    setLoading(true);
    const urlParams = new URLSearchParams(window.location.search);
    const start = urlParams.get("start");
    const end = urlParams.get("end");

    setStartDate(moment(start).format(config.date_format));
    setEndDate(moment(end).format(config.date_format));

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      StartDate: start,
      EndDate: end,
      pageNo: 1,
      pageSize: 10000,
    };

    axios({
      method: "post",
      url: config.base_url + "FeeSystem/GetAdvanceReceivedReport",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then(function (response) {
        if (response.data.status_code == 1) {
          setLedger(response.data.ListofRecords);
        }
        setLoading(false);
      })
      .catch(function () {
        setLoading(false);
      });
  }, [AccessKey, UserID, MemberType]);

  const renderLedger = () => {
    if (listOfLedger.length > 0) {
      let count = 1;
      return listOfLedger.map((item, index) => (
        <tr key={index}>
          <td>{count++}</td>
          <td>{moment(item.Dated).format(config.date_format)}</td>
          <td>{Number(item.TotalAdvanceReceived).toLocaleString()}</td>
          <td>{Number(item.RemainingAdvance).toLocaleString()}</td>
        </tr>
      ));
    }
    return (
      <tr>
        <td colSpan="4">
          <h4
            className="mt-3"
            style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
          >
            No Data Found
          </h4>
        </td>
      </tr>
    );
  };

  return (
    <Page orientation="potrait" size="a4">
      <PrintHeader
        title={`Advance Received Report from ${StartDate} to ${EndDate}`}
      />
      <table className="table table-sm table-bordered table-print">
        <thead>
          <tr>
            <th>Sr.#</th>
            <th>Received Date</th>
            <th>Advance Received (Rs.)</th>
            <th>Remaining Advance (Rs.)</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td className="text-center" colSpan="4">
                <Spinner animation="border" role="status"></Spinner>
              </td>
            </tr>
          ) : (
            <>
              {renderLedger()}
              {listOfLedger.length > 0 && (
                <tr>
                  <td colSpan={2} className="text-end">
                    Total:
                  </td>
                  <td>
                    {calculateColumnTotal(listOfLedger, "TotalAdvanceReceived")}
                  </td>
                  <td>
                    {calculateColumnTotal(listOfLedger, "RemainingAdvance")}
                  </td>
                </tr>
              )}
            </>
          )}
        </tbody>
      </table>
    </Page>
  );
};

export default PrintAdvanceReceived;
